import styles from '../style.module.css';

type Props = React.ComponentPropsWithoutRef<'button'>;

const Button = (props: Props) => {
  return <button {...props} className={styles.button} />;
};

export default Button;
